import {
	ConstructionSiteDocumentPaginatedResponse,
	ConstructionSiteForClientCompletion,
	ConstructionSiteIntervenants,
	PaginationParams,
} from "@dune/types";
import { useQuery } from "@tanstack/react-query";
import { privateAxios, publicAxios } from "../axios";
import { constructionSitesQueryKeys } from "../query-keys/constructionSites.query-keys";

export const getConstructionSiteDocuments = async (
	constructionSiteId: number,
	pagination?: PaginationParams,
): Promise<ConstructionSiteDocumentPaginatedResponse> => {
	const { data } =
		await privateAxios.get<ConstructionSiteDocumentPaginatedResponse>(
			`/constructionSites/${constructionSiteId}/documents`,
			{
				params: pagination,
			},
		);
	return data;
};

export const useGetConstructionSiteDocuments = (
	constructionSiteId: number,
	pagination?: PaginationParams,
	options?: { enabled?: boolean },
) => {
	return useQuery({
		queryKey: constructionSitesQueryKeys.documents(
			constructionSiteId,
			pagination,
		),
		queryFn: () => getConstructionSiteDocuments(constructionSiteId, pagination),
		enabled:
			options?.enabled !== undefined ? options.enabled : !!constructionSiteId,
	});
};

export const getConstructionSiteIntervenants = async (
	constructionSiteId: number,
): Promise<ConstructionSiteIntervenants> => {
	const { data } = await privateAxios.get<ConstructionSiteIntervenants>(
		`/constructionSites/${constructionSiteId}/intervenants`,
	);
	return data;
};

export const useGetConstructionSiteIntervenants = (
	constructionSiteId: number,
) =>
	useQuery({
		queryKey: constructionSitesQueryKeys.intervenants(constructionSiteId),
		queryFn: () => getConstructionSiteIntervenants(constructionSiteId),
		enabled: !!constructionSiteId,
	});

export const getPublicConstructionSiteForCompletion = async (
	constructionSiteId: number,
	token: string,
): Promise<ConstructionSiteForClientCompletion> => {
	const { data } = await publicAxios.get<ConstructionSiteForClientCompletion>(
		`/constructionSites/${constructionSiteId}/complete?token=${token}`,
	);
	return data;
};

export const useGetPublicConstructionSiteForCompletion = (
	constructionSiteId: number,
	token: string,
) => {
	return useQuery({
		queryKey: constructionSitesQueryKeys.publicCompletion(
			constructionSiteId,
			token,
		),
		queryFn: () =>
			getPublicConstructionSiteForCompletion(constructionSiteId, token),
		enabled: !!constructionSiteId && !!token,
	});
};
